<template>
  <v-layout>
    <div v-if="loading">
      <spinner />
    </div>
    <v-layout v-else column>
      <v-flex>
        <select-field
          v-if="isFloorPlan"
          v-model="form.ticketType"
          :items="localizedTicketTypes"
          item-render="text"
          item-select="value"
          :validator="vs.form.ticketType"
          :label="adminText('workflowsAll.ticket_type_74abc78', 'Ticket type')"
        />
      </v-flex>
      <v-flex class="pb-16">
        <text-field
          v-model.trim="form.name"
          autofocus
          :validator="vs.form.name"
          :label="adminText('workflowsAll.ticket_name_cb5eb35', 'Ticket name*')"
        />
      </v-flex>
      <v-layout class="pb-8">
        <text-field
          v-model.trim="form.price"
          type="number"
          step="0.01"
          :suffix="currency"
          :onwheel="true"
          :validator="vs.form.price"
          disabled
          :label="adminText('workflowsAll.price_ebb41ba', 'Price*')"
        />
      </v-layout>
      <v-flex v-if="form.ticketType !== TicketType.TABLE" class="pb-16">
        <text-field
          v-model.number="form.initialQuantity"
          type="number"
          :validator="vs.form.initialQuantity"
          :label="adminText('workflowsAll.initial_quantity_42dcebf', 'Initial quantity*')"
          :onwheel="true"
          :error-messages="{
            maxValue:
              maxInitialQuantity === 0
                ? adminText('workflowsAll.you_cannot_add_any_new_tickets_because_total__38330e9', 'You cannot add any new tickets because total tickets number already exceeded event capacity.')
                : adminText('workflowsAll.you_can_create_a_maximum_of_count_gratis_tick_fc5aceb', 'You can create a maximum of {{count}} gratis tickets.', { count: maxInitialQuantity }),
            minValue: adminText('workflowsAll.quantity_must_be_higher_than_0_979e8d5', 'Quantity must be higher than 0.'),
          }"
        />
        <div class="gratis-ticket-limit">
          {{ adminText('workflowsAll.maximum_a8df2fe', 'Maximum') }} {{ workflowLabel(maxInitialQuantity) }} {{ adminText('workflowsAll.gratis_tickets_per_creation_d64e87b', 'gratis tickets per creation.') }}
        </div>
      </v-flex>
      <p v-else class="pb-16" v-text="adminText('workflowsAll.gratis_table_quantity_hint', 'Choose ticket quantities per table in the next step. Maximum {{count}} gratis tickets per creation.', { count: maxInitialQuantity })" />
      <entry-date-range-fields :form="form" :validator="vs.form" :event="event" />
      <v-flex class="pb-16">
        <textarea-field
          v-model.trim="form.description"
          :validator="vs.form.description"
          :label="adminText('workflowsAll.ticket_description_e0c73b5', 'Ticket description')"
        />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { TicketType } from '@/types'
import EntryDateRangeFields from './entry-date-range-fields.vue'

export default {
  mixins: [WorkflowDisplay],
  name: 'gratis-ticket-form',
  components: { EntryDateRangeFields },
  props: {
    initialValues: {
      type: Object,
      default: null,
    },
    vs: {
      type: Object,
      default: () => ({}),
    },
    event: {
      type: Object,
      default: () => ({}),
    },
    currency: {
      default: null,
      type: String,
    },
    isFloorPlan: {
      default: false,
      type: Boolean,
    },
    maxInitialQuantity: null,
    ticketTypes: { type: Array, default: () => [] },
  },
  data() {
    return {
      form: this.initialValues || {},
      loading: true,
      TicketType,
    }
  },
  computed: {
    localizedTicketTypes() {
      return this.ticketTypes.map(item => ({
        ...item,
        text: item.value === TicketType.TABLE ? this.workflowTicketRowTable()
          : item.value === TicketType.REGULAR ? this.workflowTicketRowSeat() : this.workflowTicketRowParter(),
      }))
    },
  },
  mounted() {
    this.loading = false
    if (this.ticketTypes.length === 1) {
      this.form.ticketType = this.ticketTypes[0].value
    }
  },
}
</script>

<style scoped>
@media (max-width: 800px) {
  .pb-8 {
    margin-bottom: 1rem;
  }
}
</style>
